module.exports = __webpack_public_path__ + "img/cash_deposits-2.85b6cc82.svg";